import { getLogger } from '../../../services/logger';

const debug = getLogger('components:drawer-contents:AssignmentContentPanel:assignmentsContentPanelService');

export const MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  READ: 'read'
};

// Configuration modes to set the editable fields
const CONFIGURATION_MODES = {
  create: {
    title: false,
    date: true,
    groups: true,
    description: true,
    activities: true,
    saveButton: true,
    allowFile: true
  },
  edit: {
    title: true,
    date: true,
    groups: false,
    description: true,
    activities: true,
    saveButton: true,
    allowFile: true
  },
  read: {
    title: false,
    date: false,
    groups: false,
    description: false,
    activities: false,
    saveButton: false,
    allowFile: false
  }
};

export let getGroupWithId = group => {
  return {
    id: group,
    isGroup: true,
    isEveryone: group === 0
  };
};

export let getStudentsWithId = currentSelection => ({
  id: currentSelection.users.map(user => user._id),
  isGroup: false,
  isEveryone: false
});

export let getConfiguration = mode => {
  if (mode) {
    if (mode === MODES.CREATE) return CONFIGURATION_MODES.create;
    if (mode === MODES.EDIT) return CONFIGURATION_MODES.edit;
    if (mode === MODES.READ) return CONFIGURATION_MODES.read;
  } else {
    debug.error('Not configuration mode set');
  }
};
